import BusinessMan from "./BusinessMan";
import Enterprise from "./Enterprise";
import OutstandingChiefExecutive from "./OutstandingChiefExecutive";
import OutstandingOverseasExecutive from "./OutstandingOverseasExecutive";
import YoungBusinessLeader from "./YoungBusinessLeader";

/**
 * Component to render eligibility tab data in SBA how to nominate page
 */
const Eligibility = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="eligibility-component">
      <BusinessMan />

      <OutstandingChiefExecutive />

      <OutstandingOverseasExecutive />

      <Enterprise />

      <YoungBusinessLeader />
    </div>
  );
};

export default Eligibility;
